import { motion } from "framer-motion";
import { Plane } from "lucide-react";

export default function Footer({ onNavigate }) {
  return (
    <footer className="bg-charcoal text-panna px-6 sm:px-12 lg:px-24 py-16 sm:py-20" data-testid="site-footer">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          <Plane className="w-6 h-6 mx-auto text-terracotta mb-6 soft-float" />
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            Ci vediamo ai Castelli Romani
          </h2>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.3em] text-panna/60">
            F &amp; A — 22 . 05 . 2027 — Villa Grazioli, Grottaferrata
          </p>
        </motion.div>

        <div className="mt-14 pt-8 border-t border-panna/10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-panna/50">
            Due vite, un solo viaggio
          </span>
          <nav className="flex flex-wrap justify-center gap-6">
            {[
              ["storia", "La Rotta"],
              ["luogo", "Il Luogo"],
              ["lista-nozze", "Lista Nozze"],
              ["rsvp", "RSVP"],
            ].map(([id, label]) => (
              <button
                key={id}
                onClick={() => onNavigate(id)}
                className="font-mono text-[10px] uppercase tracking-[0.25em] text-panna/60 hover:text-terracotta transition-colors duration-300"
                data-testid={`footer-link-${id}`}
              >
                {label}
              </button>
            ))}
            <a
              href="/area-sposi"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-panna/60 hover:text-terracotta transition-colors duration-300"
              data-testid="footer-link-credits"
            >
              Credits
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
